// removed by extract-text-webpack-plugin
module.exports = {"property-editor":"property-editor__property-editor"};


//////////////////
// WEBPACK FOOTER
// ./src/components/encoding-pane/property-editor.scss
// module id = 1220
// module chunks = 0